import { Modal, ModalProps } from "@wfp/ui"
import { PropsWithChildren } from "react"

interface DeleteConfirmationModalProps extends ModalProps {}

export default function DeleteConfirmationModal(props: PropsWithChildren<DeleteConfirmationModalProps>) {
  const {
    children,
    modalHeading = "Confirm Delete",
    primaryButtonText = "Delete",
    secondaryButtonText = "Cancel",
    ...others
  } = props
  return (
    <Modal {...{ modalHeading, primaryButtonText, secondaryButtonText }} {...others}>
      <p> {children || "Are you sure you want to delete the selected record?"}</p>
    </Modal>
  )
}
